{
  "fr": {
    "worksheet": {
      "autoSave": {
        "saved": "Modifications enregistrées",
        "saveFailed": "Les modifications n'ont pas pu être enregistrées",
        "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter pour enregistrer les modifications.",
        "draftRestoreFailed": "Le brouillon n'a pas pu être restauré"
      },
      "submitFailed": "Échec de la soumission. Veuillez réessayer.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Cours",
          "knowledge": "Savoir",
          "topic": "Thème"
        },
        "buttons": {
          "createWorksheet": "Créer une fiche d'exercices",
          "creating": "Traitement en cours…"
        },
        "course": {
          "grade": "Niveau scolaire",
          "language": "Langue",
          "school": "Type d'établissement",
          "subject": "Matière scolaire"
        },
        "errors": {
          "generationFailed": "La fiche d'exercices n'a pas pu être créée. Veuillez réessayer."
        },
        "headers": {
          "createTitle": "Créer une fiche d'exercices avec l'assistance IA"
        },
        "knowledge": {
          "subtitle": "Tu peux éventuellement ajouter une source à partir de laquelle l'IA extraira les connaissances de base pour la fiche d'exercices."
        },
        "labels": {
          "languageLevel": "Sélectionner le niveau de langue (GER)",
          "learningObjectiveHeading": "Objectif d'apprentissage pour cette fiche d'exercices",
          "topicHeading": "Thème ou question pour cette fiche d'exercices"
        },
        "placeholders": {
          "learningObjectiveHeading": "Quelles compétences doivent être développées ? (p. ex. analyse et évaluation des conditions de départ de la République de Weimar).",
          "topicHeading": "Quels thèmes principaux la fiche d'exercices doit-elle traiter ? (p. ex. « Le début de la République de Weimar »)"
        },
        "tooltips": {
          "generateLearningObjectives": "Suggérer des objectifs d'apprentissage avec l'IA",
          "generateLearningObjectivesDisabled": "Saisissez d'abord un sujet pour obtenir des suggestions d'objectifs d'apprentissage"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Générer une tâche de texte avec l'IA"
        },
        "labels": {
          "prompt": "Exigences"
        },
        "placeholders": {
          "prompt": "Décrivez le focus de la tâche et indiquez éventuellement une question directrice ou un objectif d'apprentissage."
        },
        "description": "Que souhaitez-vous créer ?"
      },
      "aiGeneration": {
        "createWithAi": "Créer avec l'IA",
        "dropdownLabel": "Options de génération IA",
        "pending": "L'IA crée le contenu...",
        "menu": {
          "newVariant": "Varier le contenu",
          "harder": "Tâche plus difficile",
          "easier": "Tâche plus facile",
          "addHelp": "Ajouter des indications",
          "simpleLanguage": "Langage simple",
          "custom": "Demande personnalisée"
        },
        "prompts": {
          "newBlock": "Crée un bloc {blockType} adapté comme prochaine étape pertinente de cette fiche d'activité.",
          "newVariant": "Crée une variante de ce bloc : modifie le contexte, les nombres ou la formulation de sorte que la tâche ne puisse pas être résolue en se souvenant de l'original. L'objectif d'apprentissage et le niveau de difficulté restent inchangés.",
          "harder": "Rends ce bloc plus exigeant en demandant davantage de réflexion, et non davantage de travail.",
          "easier": "Rends ce bloc plus facile : simplifie la langue et la structure et supprime les informations inutiles. L'objectif d'apprentissage et les termes techniques restent inchangés ; explique les termes techniques au lieu de les remplacer.",
          "addHelp": "Ajoute des indications, des étapes intermédiaires ou des exemples utiles sans donner la solution.",
          "simpleLanguage": "Reformule ce bloc en langage simple. Conserve les termes techniques de l’objectif pédagogique et du bloc, et explique-les si nécessaire.",
          "guidance": {
            "fillInTheBlank": "Pour le texte à trous : remplis la description et le texte à trous ; varie les trous selon la demande."
          }
        }
      },
      "aiContext": {
        "title": "Focus IA pour cette fiche d'exercices",
        "button": "Paramètres IA",
        "description": "Ici, vous pouvez indiquer pour qui vous souhaitez créer la fiche d'exercices. Ces informations aident l'IA à vous proposer des tâches appropriées. Dans les différents blocs de tâches, vous pouvez demander à l'IA de vous suggérer des contenus.",
        "sections": {
          "schoolDetails": {
            "title": "Données clés scolaires"
          },
          "backgroundKnowledge": {
            "title": "Connaissances de base"
          }
        },
        "labels": {
          "subjectTypes": "Matière scolaire",
          "schoolTypes": "Type d'école",
          "gradeLevels": "Niveau de classe",
          "locale": "Langue",
          "addBackgroundKnowledge": "Ajouter des connaissances de base",
          "backgroundKnowledge": "Connaissances de base pour l'IA"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Ajoutez des connaissances de différentes sources, par exemple via le téléchargement de fichiers ainsi que depuis des sites web, des vidéos YouTube, des fichiers audio ou des vidéos."
        },
        "actions": {
          "removeSource": "Supprimer la source"
        },
        "hints": {
          "hasSources": "Sources disponibles"
        },
        "sourceKinds": {
          "text": "Texte",
          "file": "Fichier",
          "pdf": "PDF",
          "image": "Image",
          "website": "Site web",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Vidéo"
        },
        "flash": {
          "saveFailed": "Les paramètres IA n'ont pas pu être enregistrés"
        },
        "sourcePicker": {
          "title": "Ajouter des connaissances de base",
          "subtitle": "Choisissez une source et l'IA en extrait le texte comme connaissances de base pour la fiche d'exercices."
        },
        "recent": {
          "empty": "Aucune source pour le moment. Ajoutez d'abord des connaissances contextuelles.",
          "error": "Les dernières sources utilisées n'ont pas pu être chargées."
        },
        "placeholders": {
          "backgroundKnowledge": "Complétez les informations et mettez en avant les aspects de contenu qui vous tiennent particulièrement à cœur..."
        }
      },
      "blockTypes": {
        "Divider": "Ligne de séparation",
        "File": "Fichier",
        "FillInTheBlankText": "Texte à trous",
        "H5p": "H5P",
        "Hint": "Astuce",
        "Image": "Image",
        "MultipleChoice": "Choix multiple",
        "SingleChoice": "Choix unique",
        "Spacer": "Espacement",
        "PageBreak": "Saut de page",
        "StaticText": "Texte",
        "Text": "Réponse texte",
        "Upload": "Soumission de fichier",
        "Video": "Vidéo",
        "ToTeachExercise": "Exercice to teach"
      },
      "blockTypesV2": {
        "Upload": "Soumission de fichier",
        "ToTeachExercise": "Exercice to teach"
      },
      "inserterHints": {
        "toTeachExercise": "Nouveau : Utilisez vos contenus de to teach dans vos fiches d'exercices fobizz.",
        "pageBreak": "Nouveau : Concentrez la vue avec des sauts de page."
      },
      "navigation": {
        "headline": "Votre progression",
        "previousPage": "Retour",
        "nextPage": "Page suivante"
      },
      "buttons": {
        "addOption": "Ajouter une option",
        "submit": "Soumettre",
        "confirmDelete": "Oui, supprimer",
        "duplicate": "Dupliquer",
        "generate": "Générer",
        "deleteResponse": "Supprimer la soumission",
        "moveDown": "Déplacer vers le bas",
        "moveUp": "Déplacer vers le haut",
        "remove": "Supprimer",
        "removeOption": "Supprimer l'option"
      },
      "elements": "Éléments",
      "addNewBlock": "Ajouter un nouveau bloc",
      "multimedia": "Multimédia",
      "layout": "Mise en page",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Supprimer le feedback",
              "message": {
                "success": "Feedback supprimé"
              }
            },
            "submit": {
              "label": "Enregistrer le feedback",
              "message": {
                "error": "Le feedback n'a pas pu être enregistré",
                "success": "Feedback enregistré"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Écrire un message texte"
            }
          },
          "headline": "Donner un feedback individuel"
        },
        "public": {
          "headline": "Feedback de {name} sur votre soumission"
        },
        "shareLinkBox": "Partager le lien de soumission avec feedback",
        "status": {
          "hasFeedback": "Feedback donné"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Ceci est un exemple de texte à trous avec un {'{'} trou {'}'}. Plusieurs réponses peuvent être données {'{'} nombreuses/plusieurs/différentes {'}'}. Dans ce cas, 'trou' serait la réponse correcte dans la première phrase. Dans la deuxième phrase, 'nombreuses', 'plusieurs' et 'différentes' seraient correctes.",
        "description": "Votre texte de description avec des instructions pour le traitement (pas le texte à trous). Vous pouvez également proposer des suggestions de solutions pour l'association, par exemple : 'Remplissez le texte à trous avec les termes suivants : <i><mark>Mot 1</mark></i>, <i><mark>Mot 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Texte de description",
        "descriptionHint": "Utilisez le texte de description pour les instructions de traitement. Vous pouvez également proposer des suggestions de solutions pour l'association. Par exemple {italic}",
        "descriptionHintItalic": "\"Remplissez le texte à trous avec les termes suivants : Allemagne, État fédéral, République,...\"",
        "clozeLabel": "Texte à trous",
        "clozeHint": "\"Exemple de texte à trous avec un <strong>{'{'} trou {'}'}</strong>. Plusieurs <strong>{'{'} nombreuses/plusieurs {'}'}</strong> réponses peuvent être définies.\" Dans ce cas, 'trou' serait la réponse correcte et dans la deuxième phrase, 'nombreuses' et 'plusieurs' seraient correctes.",
        "insertGap": "Insérer un trou"
      },
      "flash": {
        "addOptionSuccess": "Option ajoutée",
        "createBlockSuccess": "Bloc ajouté",
        "createSolutionSuccess": "Solution ajoutée",
        "deleteBlockSuccess": "Bloc supprimé",
        "duplicateBlockSuccess": "Bloc dupliqué",
        "deleteOptionSuccess": "Option supprimée",
        "deleteSolutionSuccess": "Solution supprimée",
        "moveBlockSuccess": "Bloc déplacé",
        "updateBlockSuccess": "Bloc mis à jour",
        "updateClozeTestSuccess": "Texte à trous mis à jour",
        "updateOptionSuccess": "Option mise à jour",
        "updateSolutionSuccess": "Solution mise à jour",
        "updateWorksheetSuccess": "Fiche d'exercices mise à jour",
        "updateWorksheetError": "La fiche d'exercices n'a pas pu être mise à jour"
      },
      "headings": {
        "saveShareLink": "Notez ce lien pour retrouver facilement vos résultats plus tard."
      },
      "hints": {
        "Divider": "Utilisez la ligne de séparation pour structurer visuellement la fiche d'exercices et séparer une section de la suivante.",
        "File": "Insérez ici du matériel pédagogique (par exemple, un fichier texte, une image ou un PDF) que vos élèves doivent télécharger ou consulter. Conseil : utilisez le bloc de tâches de téléchargement pour récupérer directement le fichier traité par vos élèves.",
        "FillInTheBlankText": "Écrivez un texte à trous ou une question avec un seul trou de réponse. Utilisez les symboles {'{'} et {'}'} pour marquer un trou et entourer les mots de solution possibles. Si plus d'un mot peut être correct, séparez les mots de solution par un /. Une phrase d'exemple pourrait être : \"Les élèves doivent {'{'}un/le{'}'} trou remplir.\" Ici, 'un' et 'le' sont des réponses correctes. Toutes les réponses sont évaluées directement.",
        "H5p": "Intégrez des contenus interactifs H5P dans votre fiche d'exercices. Téléchargez un fichier .h5p pour créer des exercices interactifs, des quiz et des jeux éducatifs.",
        "Hint": "Donnez à vos élèves des conseils supplémentaires avec ce texte d'indication visuellement mis en évidence.",
        "Image": "Ajoutez une image à partir de la recherche d'images ou téléchargez votre propre image pour enrichir votre fiche d'exercices avec du contenu visuel.",
        "MultipleChoice": "Posez une question et entrez les options de réponse. Marquez les réponses correctes en cliquant sur le cercle devant. L'évaluation vous montre directement les tâches pour lesquelles vos élèves ont le plus de confiance – ou le plus besoin de répétition.",
        "SingleChoice": "Posez une question et entrez les options de réponse. Marquez la réponse correcte en cliquant sur le cercle devant. L'évaluation vous montre directement les tâches pour lesquelles vos élèves ont le plus de confiance – ou le plus besoin de répétition.",
        "Spacer": "Ajoutez des espaces à votre fiche d'exercices pour rendre le contenu plus clair.",
        "PageBreak": "Utilisez le saut de page pour diviser la fiche d'exercices en plusieurs pages entre lesquelles vous pouvez naviguer.",
        "StaticText": "Utilisez l'élément texte pour donner à vos élèves des explications, des indications et des informations supplémentaires pour traiter les tâches. Remarque : ici, vos élèves ne peuvent pas remplir numériquement, contrairement aux blocs de questions.",
        "Text": "Rédigez une tâche pour laquelle vos élèves peuvent soumettre une réponse dans un champ de texte numérique.",
        "Upload": "Formulez une tâche pour laquelle vos élèves doivent télécharger un fichier (par exemple, un fichier texte, une image ou un PDF). Vous pouvez ensuite évaluer tous les fichiers soumis en un seul endroit.",
        "ToTeachExercise": "Recherchez des exercices interactifs de to teach et intégrez-les directement dans votre fiche d'exercices.",
        "Video": "Intégrez des vidéos YouTube ou Vimeo via un lien (par exemple : https://vimeo.com/469669139).",
        "answered": "répondu",
        "dragNDrop": "Conseil : vous pouvez télécharger un fichier par glisser-déposer",
        "dropFileHere": "Glissez le fichier ici ou ",
        "dropH5pFileHere": "Glissez le fichier H5P ici ou",
        "uploadH5pFilePrompt": "Glissez le fichier H5P ici ou sélectionnez un fichier",
        "elements": "Intégrez des explications et des contenus pour vos élèves et structurez votre fiche d'exercices.",
        "h5pContentStatus": "Statut : {status}",
        "h5pFileRequirement": "Seuls les fichiers .h5p sont autorisés",
        "h5pProcessing": "Le contenu H5P est en cours de traitement, veuillez patienter...",
        "h5pProcessingFailed": "Le traitement H5P a échoué. Veuillez réessayer.",
        "h5pProcessingStalled": "Le traitement de ce contenu H5P prend un temps inhabituellement long. Veuillez réessayer plus tard ou contacter le support.",
        "h5pReloadHint": "Le contenu ne s'affiche pas ? Recharger la page",
        "h5pFileUploadSuccess": "Fichier H5P téléchargé avec succès.",
        "h5pPreviewHint": "Dans l'aperçu, vous pouvez essayer le module.",
        "toTeachExerciseImportSuccess": "Exercice to teach importé avec succès.",
        "maxOptionsReached": "Un maximum de {max} options peuvent être ajoutées.",
        "name": "Entrez ici votre pseudonyme ou vos initiales.",
        "noDescriptionOrCloze": "Aucune description et aucun texte à trous enregistrés",
        "emptyBlock": "<strong>Ce bloc est vide.</strong> Il n'apparaît ni dans l'aperçu ni dans la vue pour les élèves.",
        "noDescriptionOrOptions": "Aucune description ou option enregistrée",
        "fileUploadSuccess": "Fichier téléchargé avec succès.",
        "noFile": "Aucun fichier téléchargé",
        "noH5pContent": "Aucun contenu H5P téléchargé",
        "h5pNotPrintable": "Ce contenu interactif ne peut pas être imprimé.",
        "noHint": "Aucun conseil saisi",
        "noImage": "Aucune image téléchargée",
        "noInput": "Aucune indication",
        "selectFile": "Sélectionner un fichier",
        "noSolution": "Aucune solution enregistrée",
        "noText": "Aucun texte saisi",
        "noVideo": "Aucune vidéo intégrée",
        "processingH5pFile": "Le fichier H5P est en cours de traitement...",
        "questions": "Créez des tâches avec des champs que vos élèves peuvent remplir.",
        "submitSuccessful": "Merci ! Vous avez soumis votre fiche d'exercices avec succès.",
        "searchToTeachExercises": "Recherche d'exercices to teach...",
        "processingToTeachExercise": "L'exercice to teach est importé et traité...",
        "noToTeachExercisesFound": "Aucun exercice trouvé",
        "noToTeachExercise": "Aucun exercice to teach sélectionné",
        "toTeachSsoNotLinked": "Votre compte n'est pas encore lié à to teach. Connectez votre compte pour utiliser vos contenus to teach sur fobizz. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Accéder à to teach</a>",
        "videoError": "L'URL saisie est invalide. Entrez une adresse correcte ou supprimez votre saisie.",
        "videoExample": "Exemple : https://vimeo.com/469669139",
        "uploadFilePrompt": "Glissez le fichier ici ou sélectionnez un fichier"
      },
      "labels": {
        "clozeGap": "Espace {current} sur {total}",
        "confirmDeleteBlock": "Supprimer le bloc ?",
        "confirmDeleteBlockText": "Attention : si vous supprimez ce bloc, toutes les soumissions éventuellement associées seront également supprimées.",
        "confirmDeleteResponse": "Supprimer vraiment la soumission ?",
        "confirmDeleteResponseText": "Voulez-vous vraiment supprimer la soumission ?",
        "confirmSubmitIncompleteResponse": "Toutes les tâches ne sont pas encore terminées. Voulez-vous quand même soumettre la fiche d'exercices ?",
        "confirmSubmitResponse": "Voulez-vous soumettre la fiche d'exercices maintenant ?",
        "confirmSubmitResponseTitle": "Soumettre la fiche d'exercices ?",
        "confirmSubmitKeepEditing": "Continuer à modifier",
        "confirmSubmitAnyway": "Oui, soumettre",
        "draft": "Brouillon | Brouillons",
        "response": "Soumission | Soumissions",
        "responseStatus": {
          "draft": "En cours",
          "submitted": "Terminé"
        },
        "respondingAs": "Vous répondez à cette fiche d'exercices en tant que {pseudonym}",
        "responsesTab": "Brouillons et soumissions",
        "worksheet": "Fiche d'exercices"
      },
      "links": {
        "shareResponse": "Copier le lien d'accès",
        "showResponseSolutionToggle": "Afficher les solutions modèles",
        "taskNo": "{ index }. Tâche"
      },
      "placeholders": {
        "FillInTheBlankText": "Entrer le texte à trous ici",
        "answerInput": "Entrer la réponse ici",
        "clickToEdit": "Cliquer pour modifier",
        "description": "Entrer la description ici",
        "hint": "Entrer le conseil ici",
        "imageCaption": "Entrer la légende ici",
        "optionInput": "Entrer l'option ici",
        "videoCaption": "Entrer la légende vidéo ici",
        "videoUrl": "Entrer l'URL de la vidéo"
      },
      "questions": "Interroger",
      "solution": {
        "actions": {
          "add": "Ajouter une solution modèle",
          "delete": "Supprimer la solution modèle",
          "showResponseSolution": "Afficher toutes les solutions après soumission"
        },
        "hints": {
          "showResponseSolution": "Tes élèves voient les solutions modèles enregistrées directement après la soumission."
        },
        "title": "Solution modèle",
        "types": {
          "text": {
            "placeholder": "Entrer la solution modèle ici..."
          }
        }
      },
      "words": {
        "of": "de"
      },
      "h5pForm": {
        "question": "Question",
        "statement": "Affirmation",
        "statementCorrect": "L'affirmation est correcte",
        "task": "Exercice",
        "sentence": "Phrase {number}",
        "sentencesHint": "Marquez les trous avec des astérisques, ex. : Le soleil est une *étoile*. Séparez plusieurs réponses correctes par /, ex. : *étoile/étoile fixe*.",
        "option": "Réponse {number}",
        "optionCorrect": "La réponse {number} est correcte",
        "addOption": "Ajouter une réponse",
        "removeOption": "Supprimer la réponse",
        "addSentence": "Ajouter une phrase",
        "removeSentence": "Supprimer la phrase",
        "questionNumber": "Question {number} sur {count}",
        "removeQuestion": "Supprimer la question",
        "addQuestion": {
          "multiChoice": "Ajouter une question à choix multiples",
          "trueFalse": "Ajouter une question vrai ou faux",
          "blanks": "Ajouter un texte à trous"
        },
        "kinds": {
          "multiChoice": "Choix multiples",
          "trueFalse": "Vrai ou faux",
          "blanks": "Texte à trous"
        },
        "autosaved": "Les modifications sont automatiquement enregistrées et appliquées en quittant le bloc.",
        "rebuilding": "Mise à jour en cours…",
        "errorsTitle": "L'exercice ne peut pas être repris ainsi :",
        "publishFailed": "L'exercice n'a pas pu être mis à jour. Vos modifications sont enregistrées.",
        "replaceFile": "Remplacer par un fichier H5P",
        "backToForm": "Retour au formulaire",
        "replaceConfirm": {
          "title": "Remplacer l'exercice H5P ?",
          "text": "L'exercice actuel et vos modifications non appliquées seront remplacés par le fichier téléchargé.",
          "confirm": "Télécharger un fichier"
        },
        "answer": "Mot de solution {number}",
        "clue": "Indice {number}",
        "crosswordHint": "Chaque mot de solution est un seul mot composé de lettres, sans espaces. Le puzzle organise lui-même les mots.",
        "word": "Mot {number}",
        "findTheWordsHint": "Les mots sont cachés dans la grille de lettres. Chaque mot ne peut apparaître qu'une seule fois.",
        "addWord": "Ajouter un mot",
        "removeWord": "Supprimer un mot",
        "dragText": "Texte",
        "dragTextHint": "Place chaque mot à faire glisser entre astérisques, ex. : La capitale est *Berlin*. Un indice s'écrit après deux-points : *Berlin:se trouve sur la Spree*.",
        "distractors": "Distracteurs",
        "distractorsHint": "Mots faux supplémentaires à faire glisser, chacun entre astérisques, ex. : *Hambourg* *Danube*. Peut rester vide."
      },
      "h5pInserter": {
        "title": "Exercices interactifs (H5P)",
        "upload": "Télécharger H5P",
        "types": {
          "questionSet": "Quiz",
          "crossword": "Mots croisés",
          "findTheWords": "Recherche de mots",
          "dragText": "Glisser des mots"
        }
      }
    }
  }
}
